import React, { useState } from 'react';
import { Square, Building2, Layers, Boxes, Sun, Wrench, ArrowRight } from 'lucide-react';
import { servicesData } from '../mock';

const iconMap = {
  Square,
  Building2,
  Layers,
  Boxes,
  Sun,
  Wrench
};

export const Services = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section id="services" className="relative py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block mb-4">
            <span className="text-sm tracking-[0.3em] uppercase text-gray-500 font-light">
              Our Services
            </span>
            <div className="h-px w-16 bg-gray-900 mt-2 mx-auto" />
          </div>
          <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-6">
            Precision-Engineered Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Comprehensive architectural aluminium and glazing services tailored to modern construction excellence
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                className="group relative bg-white rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/40 to-transparent" />
                  
                  {/* Icon */}
                  <div className="absolute top-6 left-6">
                    <div className="w-12 h-12 rounded-lg bg-white/20 backdrop-blur-md flex items-center justify-center border border-white/30 transition-all duration-500 group-hover:bg-white group-hover:scale-110">
                      <Icon className="w-6 h-6 text-white group-hover:text-gray-900 transition-colors duration-500" />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-medium text-gray-900 mb-3 leading-tight">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    {service.description}
                  </p>
                  
                  {/* Learn More Link */}
                  <div className="flex items-center gap-2 text-gray-900 text-sm font-medium group-hover:gap-4 transition-all duration-300">
                    <span>Learn More</span>
                    <ArrowRight className="w-4 h-4" />
                  </div>
                </div>

                {/* Sliding Border Effect */}
                <div className={`absolute bottom-0 left-0 h-1 bg-gray-900 transition-all duration-500 ${
                  hoveredIndex === index ? 'w-full' : 'w-0'
                }`} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};